module.exports = __webpack_public_path__ + "static/media/micro.4adfe13e.jpg";